import { Avatar } from "~/components/ui";
import type { FunctionComponent } from "react";

interface PredefinedTaskIconProps {
  icon: React.ReactNode;
}

export const PredefinedTaskIcon: FunctionComponent<PredefinedTaskIconProps> = ({ icon }) => {
  return <Avatar icon={icon} size={32} className="mr-3" />;
};
